import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles/index';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';

import { setTargetValue } from '../../../store/actions/metadata.actions';
import { addMessage } from '../../../store/actions/message.actions';

const styles = {
  btnPadding: {
    marginLeft: '10px',
    width: '25%'
  },
  hide: {
    display: 'none',
  },
  field: {
    width: '71%',
  },
};

class DefineMappingComponent extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      columnName: this.props.column.name,
      saved: true,
    };
  }

  handleChange(event) {
    const sameValue = this.props.column.name === event.target.value;
    this.setState({
      columnName: event.target.value,
      saved: sameValue,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { columnName } = this.state;
    const {
      column,
      metadata,
    } = this.props;

    if (columnName.replace(/\s/g, '') === '') {
      this.props.addMessage('error', 'Target cannot be empty');
    } else if (column.name === columnName) {
      this.props.addMessage('error', 'Target can not be the same as source value');
    } else if (_.find(metadata, c => c.source === columnName)) {
      this.props.addMessage('error', 'Name already in use as source value');
    } else if (_.some(metadata, c => c.name === columnName)) {
      this.props.addMessage('error', 'Name already in use as target value');
    } else {
      this.props.setTargetValue(column.key, columnName);
      this.setState({ saved: true });
      this.props.addMessage('success', 'Changed target value');
    }
  }

  render() {
    const { classes, column } = this.props;
    const { saved } = this.state;
    return (
      <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
        <TextField
          onChange={this.handleChange}
          value={this.state.columnName}
          disabled={column.type === 'Skip'}
          className={classes.field}
        />
        <Button className={classes.btnPadding} type="submit" variant="contained" size="small" color="primary" disabled={column.type === 'Skip' || saved}>
          {saved ? <Icon>check</Icon> : 'Save'}
        </Button>
      </form>
    );
  }
}

DefineMappingComponent.propTypes = {
  column: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  addMessage: PropTypes.func.isRequired,
  setTargetValue: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(
  null,
  { addMessage, setTargetValue },
)(DefineMappingComponent));
